export class tourModifySearch {
  state_id?: number;
  // destination_abbreviation?: string;
  searchDate?: any;
}
